import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent, IconName } from '@cumlaude/shared-components-icons';

@Component({
	selector: 'app-meatball-menu-item',
	templateUrl: './meatball-menu-item.component.html',
	styleUrls: ['./meatball-menu-item.component.scss'],
	imports: [IconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeatballMenuItemComponent {
	@Input()
	icon?: IconName;
}
